import { render, staticRenderFns } from "./carrierAbnormal.vue?vue&type=template&id=3d02f974&scoped=true&"
import script from "./carrierAbnormal.vue?vue&type=script&lang=js&"
export * from "./carrierAbnormal.vue?vue&type=script&lang=js&"
import style0 from "./carrierAbnormal.vue?vue&type=style&index=0&id=3d02f974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d02f974",
  null
  
)

export default component.exports